var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{attrs:{"mandatory":true},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"disabled":_vm.isValid,"label":_vm.titleAndCosts,"value":_vm.keyword}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb0c8e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventComponentItem.vue
// module id = null
// module chunks = 